import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import WorkspaceView from "@/views/WorkspaceView.vue";

const screens = [
  { path: "/", name: "home", screen: "home" },
  { path: "/users", name: "users", screen: "users" },
  { path: "/deploy-units", name: "deploy-units", screen: "deploy-units" },
  { path: "/deploy-steps", name: "deploy-steps", screen: "deploy-steps" },
  { path: "/rings", name: "rings", screen: "rings" },
  { path: "/customers", name: "customers", screen: "customers" },
  { path: "/notes", name: "notes", screen: "notes" },
  { path: "/planned", name: "planned", screen: "planned" },
  { path: "/deploy", name: "deploy", screen: "deploy" },
  { path: "/history", name: "history", screen: "history" },
  { path: "/branches", name: "branches", screen: "branches" },
  { path: "/applications", name: "applications", screen: "applications" },
  { path: "/docs", name: "docs", screen: "docs" },
];

const routes: Array<RouteRecordRaw> = screens.map((entry) => ({
  path: entry.path,
  name: entry.name,
  component: WorkspaceView,
  props: {
    screen: entry.screen,
  },
}));

routes.push({
  path: "/:pathMatch(.*)*",
  redirect: "/",
});

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
